<template>
  <div v-if="checkSubdomain">
    <login-with-subdomain></login-with-subdomain>
  </div>
  <div v-else>
    <login-without-subdomain></login-without-subdomain>
  </div>
</template>
<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import * as types from 'src/app/pages/auth/vuex/mutations-types'
  import LoginWithSubdomain from './components/LoginWithSubdomain'
  import LoginWithoutSubdomain from './components/LoginWithoutSubdomain'

  export default {
    components: { LoginWithSubdomain, LoginWithoutSubdomain },
    methods: {
      ...mapActions(['loadFullUser']),
      ...mapMutations(['clearFlash', 'addFlash']),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.doLogin)
      },
      afterRetrieveUserData (response) {
        if (response && response.status === 200) {
          this.$router.push('/wizard')
        }
        this.$loader.hide()
      }
    },
    computed: {
      ...mapGetters(['isLogged']),
      checkSubdomain () {
        let url = window.location.host
        return (url === process.env.URL_PORTAL)
      }
    },
    mounted () {
      let url = window.location.host

      if (process.env.NODE_ENV === 'development') {
        url = url.replace('.yapay', '.portal.yapay')
      }

      if (process.env.NODE_ENV === 'test') {
        url = url.replace('assinaturas.teste', 'recorrencia-teste')
      }

      if (process.env.NODE_ENV === 'sandbox') {
        url = url.replace('assinaturas.sandbox', 'recorrencia-sandbox')
      }

      if (process.env.NODE_ENV === 'production') {
        url = url.replace('assinaturas', 'recorrencia')
      }

      window.location.href = 'https://' + url

      if (this.$route.query.token) {
        this.$store.commit(types.setUserToken, this.$route.query.token)
        this.$store.commit(types.setIsLogged, true)
        this.loadFullUser().then(this.afterRetrieveUserData)
      }
      if (window.localStorage.message) {
        let message = JSON.parse(window.localStorage.message)
        this.addFlash(message)
        window.localStorage.removeItem('message')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @-moz-document url-prefix() {
    .ls-prefix-group {
      margin: 0!important;
    }
    .forgot-password {
      margin-top: 11px!important;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  .forgot-password {
    font-size: 11px;
    display: initial;
    top: 5px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// Main.vue?1c681e9d